<div class="flex flex-col max-w-240 md:min-w-160 max-h-screen -m-6 dms-modal" 
    >

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">Upload File</div>
        <button mat-icon-button (click)="cancel()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <!-- Compose form -->
    <form class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto" [formGroup]="createFolderForm">

        <!-- Folder Name-->

        <mat-form-field class="w-full">
            <mat-label>File Name</mat-label>
            <input matInput [formControlName]="'folderName'" [value]="'Untitled Folder'" [(ngModel)]="folder.name">
            <mat-error *ngIf="createFolderForm.get('folderName').hasError('required')">
                Folder Name is required
            </mat-error>
        </mat-form-field>

        <!-- <mat-form-field>
            <mat-label>Folder Name</mat-label>
            <input
                matInput
                [formControlName]="'folderName'" [value]="'Untitled Folder'">
        </mat-form-field> -->

        <!-- Description -->

        <!-- <mat-label>Description</mat-label>
        <quill-editor [(ngModel)]="folder.description"  [bounds]="'self'" class="mt-2" [formControlName]="'description'" [modules]="getEditorToolbar()"></quill-editor> -->
        <!-- Actions -->
        <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4 sm:mt-6">
            <div class="flex items-center justify-end mt-4 sm:mt-0">
                <!-- Cancel -->
                <button class="ml-auto sm:ml-0 mr-2" mat-stroked-button (click)="cancel()">
                    Cancel
                </button>

                <!-- Save -->
                <!-- <button class="order-first sm:order-last" mat-flat-button [color]="'primary'" (click)="saveAndClose()">
                    Create
                </button>
                <mat-progress-spinner
                    *ngIf="createFolderForm.disabled"
                    [diameter]="24"
                    [mode]="'indeterminate'"></mat-progress-spinner> -->

                    <button
                    class="order-first sm:order-last"
                    mat-flat-button
                    [color]="'primary'"
                    [disabled]="createFolderForm.disabled"
                    (click)="saveAndClose()">
                    <span *ngIf="!createFolderForm.disabled">
                        Create
                    </span>
                    <mat-progress-spinner
                        *ngIf="createFolderForm.disabled"
                        [diameter]="24"
                        [mode]="'indeterminate'"></mat-progress-spinner>
                </button>
            </div>
        </div>
    </form>
</div>

<!-- <div>
    <file-manager-list></file-manager-list>
</div> -->

<!-- <fuse-alert class="mt-8" *ngIf="showAlert" [appearance]="'outline'" [showIcon]="false" [type]="alert.type"
    [@shake]="alert.type === 'error'">
    {{alert.message}}
</fuse-alert> -->